import React, { useState, useEffect, useContext, useRef } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';


import SearchFilter from '../../../components/filters/search';
import DatePicker from '../../../components/filters/datePicker';

import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card, Divider } from 'antd';

import { FcViewDetails } from "react-icons/fc";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '../../../components/dropDown/selectStyle';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';
import ViewModal from '../../../components/modals/viewModal';





function AccountStatement(props) {

  let { type, isDebit } = props;

  const { api, userData, settingData, auxAccountData, refData, companyId, selectedYear,
    yearId, mainCurrency, secondaryCurrency, currencyOptions } = useContext(DataContext);

  const reportRef = useRef(null);

  const statementreportRef = useRef(null);
    
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;
  const [showReportModal, setShowReportModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['auxAccount', 'currency']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);



  const table = 'accountStatement';
  const title = 'Statement';


  const fromDate = selectedYear?.year + '-01-01';
  const toDate = selectedYear?.year+ '-12-31';

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', fromDate: fromDate, toDate: toDate, companyId, yearId });

  //change Type
  useEffect(() => {
    setFilter(prevFilter => ({ ...prevFilter, accountId: selectedAccount?.value, currencyId: selectedCurrency?.value }));
  }, [selectedAccount, selectedCurrency]);


  const [showViewModal, setShowViewModal] = useState(false);

  // Account Options
  const accountOptions = auxAccountData?.map(item => ({
    value: item.id,
    label: (item?.parent?.accountId ? item?.parent?.accountId + '.' : '') + item.accountId + ' ' + item.english,
  }));

  // Load and filter account options
  const loadAccountOptions = (inputValue, callback) => {
    const filteredOptions = inputValue ? accountOptions.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
    callback(filteredOptions);
  };



  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }




  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        "Jv-ID": item.journalVoucherId,
    Date: item.journalVoucher?.date,
    Type: item.journalVoucher?.type,
    Currency: item.currency?.code,
    Debit: numberFormatter(item.debit),
    Credit: numberFormatter(item.credit),
    [`Debit ${mainCurrency?.code}`]: numberFormatter(item.totalDebit),
    [`Credit ${mainCurrency?.code}`]: numberFormatter(item.totalCredit),
    [`Debit ${secondaryCurrency?.code}`]: numberFormatter(item.secondaryTotalDebit),
    [`Credit ${secondaryCurrency?.code}`]: numberFormatter(item.secondaryTotalCredit),
    [`Balance ${mainCurrency?.code}`]: numberFormatter(item.cumulativeBalance),
    [`Balance ${secondaryCurrency?.code}`]: numberFormatter(item.secondaryCumulativeBalance),
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };

  const handlePrint = () => {
    setShowReportModal(true);
  };



  let newColumnDefs = [
    { title: 'Jv-ID', dataIndex: 'journalVoucherId', width: '5%', sorter: (a, b) => a.age - b.age },
    { title: 'Date', dataIndex: 'journalVoucher', render: (journalVoucher) => (journalVoucher?.date), width: '8%' },
    { title: 'Details', dataIndex: 'details' , width: '10%'},
    { title: 'Type', dataIndex: 'journalVoucher', render: (journalVoucher) => (journalVoucher?.type), width: '6%' },
    { title: 'Currency', dataIndex: 'currency', render: (currency) => (currency?.code), width: '5%' },
    { title: 'Debit', dataIndex: 'debit', render: numberFormatter },
    { title: 'Credit', dataIndex: 'credit', render: numberFormatter },
    { title: 'Debit ' + mainCurrency?.code, dataIndex: 'totalDebit', render: numberFormatter },
    { title: 'Credit ' + mainCurrency?.code, dataIndex: 'totalCredit', render: numberFormatter },
    { title: 'Debit ' + secondaryCurrency?.code, dataIndex: 'secondaryTotalDebit', render: numberFormatter },
    { title: 'Credit ' + secondaryCurrency?.code, dataIndex: 'secondaryTotalCredit', render: numberFormatter },
    { title: 'Balance' + mainCurrency?.code, dataIndex: 'cumulativeBalance', render: numberFormatter },
    { title: 'Balance' + secondaryCurrency?.code, dataIndex: 'secondaryCumulativeBalance', render: numberFormatter },
    {
      title: 'View',
      width: '5%',
      render: (_, record) => (
        <FcViewDetails size={20} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
      ),
    }
  ];


  const tableFooter = (
    <div style={{ marginRight: "550px" }}>
      <Tag color="green" style={{ fontSize: '18px' }}>
      </Tag>
    </div>
  )

  const report = (
    <Card
      title={<div style={{ textAlign: 'center', fontSize: 40 }}>Account Statement</div>}
      bordered={true}
      style={{ width: '100%', alignSelf: 'center' }}
      headStyle={{ textAlign: 'center' }}
      ref={reportRef}
    >
      <div style={{ width: '80%', margin: '0 auto' }}>
        {/* Date */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h5 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Date:</h5>
          <h5>{filter.fromDate} to {filter.toDate}</h5>
        </div>
  
        {/* Account */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h5 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Account:</h5>
          <h5>{selectedAccount?.label || 'All Accounts'}</h5>
        </div>
  
        {/* Currency */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h5 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Currency:</h5>
          <h5>{selectedCurrency?.label || 'All Currencies'}</h5>
        </div>
  
        <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />
  
        {/* Summary Section */}
        <h5 style={{ textDecoration: 'underline', fontWeight: 'bold', marginTop: '30px' }}>Summary</h5>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h5>Total Debit ({mainCurrency?.code}):</h5>
            <h5>{numberFormatter(data?.summary?.totalDebit, 2)}</h5>
          </div>
  
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h5>Total Credit ({mainCurrency?.code}):</h5>
            <h5>{numberFormatter(data?.summary?.totalCredit, 2)}</h5>
          </div>
  
          <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h5 style={{ textDecoration: 'underline', fontWeight: 'bold', fontSize: '25px' }}>Balance ({mainCurrency?.code}):</h5>
            <h5 style={{ 
              color: (data?.summary?.totalDebit - data?.summary?.totalCredit) > 0 ? 'green' : 'red', 
              fontSize: '25px' 
            }}>
              {numberFormatter(data?.summary?.totalDebit - data?.summary?.totalCredit, 2)}
            </h5>
          </div>
        </div>
      </div>
    </Card>
  );

  const statementReport = (
    <Card
    ref={statementreportRef}
      >
      {/* Title */}
      <div style={{ textAlign: 'center', fontSize: 20, fontWeight: 'bold', color: '#000', marginBottom: 16 }}>
        STATEMENT OF ACCOUNT
      </div>
  
      {/* Header Information */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 24,
          fontSize: 14,
        }}
      >
        <div><strong>Period:</strong> {filter.fromDate} to {filter.toDate}</div>
        <div><strong>Account:</strong> {selectedAccount?.label || 'All Accounts'}</div>
        <div><strong>Currency:</strong> {selectedCurrency?.label || 'All Currencies'}</div>
      </div>
  
      {/* Table */}
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginTop: 16,
          border: '1px solid #000',
        }}
      >
        <thead>
          <tr>
            {['ID', 'Date', 'Type', 'Debit', 'Credit', 'Balance'].map((header, index) => (
              <th
                key={index}
                style={{
                  textAlign: index > 2 ? 'right' : 'left',
                  padding: '10px',
                  borderBottom: '2px solid #000',
                  borderRight: index !== 5 ? '1px solid #000' : 'none',
                  fontWeight: 'bold',
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.map((item, index) => {
            const useMainCurrency = !selectedCurrency || selectedCurrency?.value === mainCurrency?.value;
            const formattedDate = new Date(item.journalVoucher?.date).toLocaleDateString();
  
            return (
              <tr key={index} style={{ borderBottom: '1px solid #000' }}>
                <td style={{ padding: '10px', borderRight: '1px solid #000' }}>{item.journalVoucherId}</td>
                <td style={{ padding: '10px', borderRight: '1px solid #000' }}>{formattedDate}</td>
                <td style={{ padding: '10px', borderRight: '1px solid #000' }}>{item.journalVoucher?.type}</td>
                <td style={{ textAlign: 'right', padding: '10px', borderRight: '1px solid #000' }}>
                  {numberFormatter(useMainCurrency ? item.totalDebit : item.secondaryTotalDebit)}
                </td>
                <td style={{ textAlign: 'right', padding: '10px', borderRight: '1px solid #000' }}>
                  {numberFormatter(useMainCurrency ? item.totalCredit : item.secondaryTotalCredit)}
                </td>
                <td style={{ textAlign: 'right', padding: '10px' }}>
                  {numberFormatter(useMainCurrency ? item.cumulativeBalance : item.secondaryCumulativeBalance)}
                </td>
              </tr>
            );
          })}
  
          {/* Summary Row */}
          <tr style={{ fontWeight: 'bold', borderTop: '2px solid #000' }}>
            <td colSpan="3" style={{ padding: '10px', borderRight: '1px solid #000' }}>TOTAL</td>
            <td style={{ textAlign: 'right', padding: '10px', borderRight: '1px solid #000' }}>
              {numberFormatter(!selectedCurrency || selectedCurrency?.value === mainCurrency?.value 
                ? data?.summary?.totalDebit 
                : data?.summary?.secondaryTotalDebit)}
            </td>
            <td style={{ textAlign: 'right', padding: '10px', borderRight: '1px solid #000' }}>
              {numberFormatter(!selectedCurrency || selectedCurrency?.value === mainCurrency?.value 
                ? data?.summary?.totalCredit 
                : data?.summary?.secondaryTotalCredit)}
            </td>
            <td style={{ textAlign: 'right', padding: '10px' }}>
              {numberFormatter(!selectedCurrency || selectedCurrency?.value === mainCurrency?.value 
                ? (data?.summary?.totalDebit || 0) - (data?.summary?.totalCredit || 0) 
                : (data?.summary?.secondaryTotalDebit || 0) - (data?.summary?.secondaryTotalCredit || 0))}
            </td>
          </tr>
        </tbody>
      </table>
  
      {/* Footer */}
      <div
        style={{
          marginTop: 24,
          textAlign: 'right',
          fontSize: 12,
          color: '#000',
          padding: '10px 0',
          borderTop: '1px solid #000',
        }}
      >
        Generated on: {new Date().toLocaleDateString()} by {userData.name}
      </div>
      </Card>
  );
  
  
  

  return (
    <div>

      {isLoading &&
        <Loader />
      }

      {!isLoading &&
        <div>


          <Row className="mb-3 g-1">
            <Col md={3}>
              <AsyncSelect
                styles={selectStyles}
                cacheOptions
                isClearable={true}
                loadOptions={loadAccountOptions}
                defaultOptions={[]}
                onChange={setSelectedAccount}
                value={selectedAccount}
                noOptionsMessage={() => 'type to view'}
                placeholder="Select Account"
              />
            </Col>

            <Col md={1}>
              <Select
                styles={selectStyles}
                options={currencyOptions}
                isSearchable={true}
                isClearable={true}
                placeholder="Currency"
                onChange={setSelectedCurrency}
                value={selectedCurrency}
                required
              />
            </Col>




            {filter?.accountId &&


              <>


                <Col md={2}>
                  <SearchFilter setFilter={setFilter} />
                </Col>

                <Col md={3}>
                  <DatePicker setFilter={setFilter} filter={filter} />
                </Col>


                <Col md={1}>
                </Col>




                <Col md={2} className="d-flex justify-content-end">
                  <Button onClick={refreshTableFunction}>
                    <FiPrinter size={18} />
                  </Button>
                  <Button onClick={refreshTableFunction}>
                    <FiRotateCcw size={18} />
                  </Button>
                </Col>
              </>

            }

          </Row>




          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={newColumnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
            height={true}
            report={report}
            reportRef={reportRef}
            statementreportRef={statementreportRef}
            statementreport={statementReport}
          />


          <ViewModal
            showModal={showViewModal}
            toggleModal={viewModal}
            journalVoucherId={idRow?.journalVoucherId}
          />


        </div>
      }


    </div >
  )
}

export default AccountStatement;
